import React, { FC } from "react";
import { AuthPageLayout } from "../components/auth-page-layout/auth-page-layout.component";

export const NotFound: FC = () => (
    <AuthPageLayout>
        <div className="flex flex-1 justify-center">
            <h1>404: Page not found.</h1>
        </div>
    </AuthPageLayout>
)